<template>
    <b-modal
        id="companyCreateModal"
        ref="companyCreateModal"
        :lazy="true"
        title-tag="h2"
        title="New Company"
    >
        <company ref="newCompanyForm" />

        <div slot="modal-footer" class="w-100">
            <b-button
                v-if="!loading"
                @click="$refs.companyCreateModal.hide()"
                class="float-left"
                variant="secondary"
                >Cancel</b-button
            >
            <div class="float-right">
                <img v-if="loading" src="assets/ajax-loader.gif" />
                <b-button @click="save" v-else variant="primary">Save</b-button>
            </div>
        </div>
    </b-modal>
</template>
<script>
import Company from "./form.vue";
import Services from "@/services/contacts";

export default {
    components: {
        Company
    },
    data() {
        return {
            loading: false
        };
    },
    computed: {
        contactData() {
            return this.$store.getters["contact/selected"];
        }
    },
    methods: {
        open(event) {
            let details = {
                name: "",
                phone: "",
                fax: "",
                email: "",
                website: "",
                account_no: "",
                phone_country_code: null,
                fax_country_code: null,
                address: null,
                city: null,
                state: null,
                zipcode: null,
                country: null,
                county: null
            };

            details = _.merge(details, event);
            this.$store.commit("contact/setSelected", details);
            this.$refs.companyCreateModal.show();
        },
        save() {
            let self = this;
            self.$refs.newCompanyForm.$validator.validateAll().then(result => {
                if (result) {
                    self.loading = true;
                    Services.createContactCompany(self.contactData)
                        .then(function (response) {
                            let savedData = response.resource;
                            if (savedData.label === undefined) {
                                savedData.label = savedData.name;
                            }
                            savedData.type = self.ACTOR_REFERRAL.SOURCE_COMPANY;
                            savedData.fullname = savedData.name;
                            savedData.contact_type = "business";
                            self._message(
                                "Company successfully added",
                                "success"
                            );
                            self.$emit("saved", savedData);
                            self.$refs.companyCreateModal.hide();
                        })
                        .catch(e => {
                            this._message(
                                "Error : unable to add this company.",
                                "danger"
                            );
                            console.error(e);
                        })
                        .finally(() => (self.loading = false));
                }
            });
        }
    }
};
</script>
